import moment from "moment-timezone"

export const createNewDate = (date, isGetDay = false) => {
  return new Date(date.year(), date.month(), isGetDay ? date.date() : 1)
}

export const createNewMomentDate = date => {
  return moment(date).seconds(0)
}
